import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RseQuestion, SupplierRseAnswer, SupplierRseAnswersIndex, } from '../../../../all-models';
import { SupplierRseAnswers } from '../SupplierRseAnswers';
import { ControlContainer, NgForm } from '@angular/forms';
import { SharedDataService } from  '../../../../all-services';

@Component({
  selector: 'app-supplier-rse-answer',
  templateUrl: './supplier-rse-answer.component.html',
  styleUrls: ['./supplier-rse-answer.component.scss'],
  viewProviders:[{ provide: ControlContainer, useExisting: NgForm }]
})
export class SupplierRseAnswerComponent implements AfterViewInit{

  constructor(public sharedDatasSvc:SharedDataService) { }

  @Input() supplierAnswsers!:SupplierRseAnswers;
  @Input() rseQuestion!: RseQuestion;
  @Input() readonly: boolean = true;
  @Input() frmRse: NgForm;

  @ViewChild('unchecked') uncheckedRadio : ElementRef;
  @ViewChild('checked') checkedRadio : ElementRef;
  

  ngAfterViewInit(): void {
    setTimeout(()=>{
      if (this.uncheckedRadio) this.uncheckedRadio.nativeElement.disabled =  this.readonly;
      if (this.checkedRadio) this.checkedRadio.nativeElement.disabled = this.readonly;
    },0);
  }

  get answerOptionName():string {
    if (this.rseQuestion){
      return `answer-${this.rseQuestion.Id}`;
    } else {
      return '';
    }
  }

get answer():SupplierRseAnswer | undefined {
  return this.supplierAnswsers.questionAnswer(this.rseQuestion.Id);
}

get visibleAnswerIdx():SupplierRseAnswersIndex[] {
  return this.supplierAnswsers.visibleAnswerIdx(this.rseQuestion.Id);
}

  onValueChanged(newValue: number):void {
      this.supplierAnswsers.onValueChanged();
  }

}
